import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AdminUserList from './AdminUserList';
import AccessUserList from './AccessUserList';
import RoleList from './RoleList';
import GroupList from './GroupList';
import AuditList from './AuditList';

type Tab = 'admin' | 'user' | 'roledef' | 'group' | 'audit';

/**
 * 权限管理 (2026-09-13 由「用户管理」改名): 管理员 / 用户管理 (准入名单) + 角色管理 (授权) + 用户组 (批量授权) 四个 tab.
 * 2026-09-12: 「权限分配」tab 移除 —— 给人配角色在用户行的「权限分配」按钮里, 给角色配人在「角色管理」的「成员」里.
 * tab 状态走 URL query (?tab=admin|user), 与 SchemaAdmin 同范式, 刷新/分享不丢位.
 */
function UserManage() {
    const history = useHistory();
    const location = useLocation();
    const [tab, setTab] = useState<Tab>(() => {
        const q = new URLSearchParams(location.search).get('tab');
        if (q === 'user') return 'user';
        if (q === 'roledef') return 'roledef';
        if (q === 'group') return 'group';
        if (q === 'audit') return 'audit';
        return 'admin';
    });

    const switchTab = (next: Tab) => {
        setTab(next);
        const params = new URLSearchParams(location.search);
        params.set('tab', next);
        history.replace({
            pathname: location.pathname,
            search: params.toString(),
        });
    };

    return (
        <div className="space-y-5">
            <div className="flex items-center gap-1 border-b border-slate-200">
                {(
                    [
                        { key: 'admin', label: '管理员' },
                        { key: 'user', label: '用户管理' },
                        { key: 'roledef', label: '角色管理' },
                        { key: 'group', label: '用户组' },
                        { key: 'audit', label: '变更记录' },
                    ] as { key: Tab; label: string }[]
                ).map((t) => (
                    <button
                        key={t.key}
                        type="button"
                        onClick={() => switchTab(t.key)}
                        className={`px-4 py-2 text-sm border-b-2 -mb-px ${
                            tab === t.key
                                ? 'border-brand-600 text-brand-600 font-medium'
                                : 'border-transparent text-slate-500 hover:text-slate-700'
                        }`}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
            {tab === 'admin' && <AdminUserList />}
            {tab === 'user' && <AccessUserList />}
            {tab === 'roledef' && <RoleList />}
            {tab === 'group' && <GroupList />}
            {tab === 'audit' && <AuditList />}
        </div>
    );
}

export default UserManage;
